import {
  USER_ADJUST_CART_ITEM_LOADING,
  USER_ADJUST_CART_ITEM_SUCCESS,
  USER_ADJUST_CART_ITEM_FAILURE,
} from "redux/types";

const initialState = {
  userAdjustCartItemLoading: false,
  adjustCartItemData: null,
  errors: null,
};

export const userAdjustCartItemReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case USER_ADJUST_CART_ITEM_LOADING:
      return { ...state, userAdjustCartItemLoading: action.payload };
    case USER_ADJUST_CART_ITEM_SUCCESS:
      return { ...state, adjustCartItemData: action.payload };
    case USER_ADJUST_CART_ITEM_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
